import { deepColumns } from "@/mocks/gossip";

export default function DeepDive() {
  return (
    <section id="column" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <p className="text-xs font-medium uppercase tracking-widest text-accent-600">Deep Columns</p>
          <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
            深度专栏 · 吃瓜也吃透
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            不止搬运瓜，更把背后的门道掰开揉碎讲清楚。每周特约作者带来的长文栏目。
          </p>
        </div>

        <div className="flex flex-col gap-6">
          {deepColumns.map((col, idx) => (
            <article
              key={col.id}
              className={`group grid items-center gap-6 overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-4 md:p-6 lg:grid-cols-[0.9fr_1.1fr] ${
                idx % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div className="relative overflow-hidden rounded-xl">
                <img
                  src={col.img}
                  alt={col.title}
                  className="aspect-[16/10] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col gap-3 p-2 md:p-3">
                <div className="flex flex-wrap items-center gap-2.5 text-xs">
                  <span className="rounded-full bg-primary-500/10 px-2.5 py-1 font-medium text-primary-700">
                    {col.tag}
                  </span>
                  <span className="inline-flex items-center gap-1 text-foreground-500">
                    <i className="ri-user-line" aria-hidden="true"></i> {col.author}
                  </span>
                  <span className="inline-flex items-center gap-1 text-foreground-500">
                    <i className="ri-time-line" aria-hidden="true"></i> {col.length}
                  </span>
                </div>
                <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  {col.title}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-600 md:text-base">{col.deck}</p>
                <a
                  href="#subscribe"
                  className="mt-1 inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
                >
                  阅读全文
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}